(() => {
	// preloader js
	const loader = document.querySelector("#preloader");
	if (loader) {
		// window.addEventListener("load", () => {
		// 	setTimeout(() => {
		// 		loader.classList.add("hidden");
		// 	}, 200);
		// });
		setTimeout(() => {
			loader.classList.add("hidden");
		}, 300);
	}
})();
//after window is loaded completely
// window.onload = function () {
// 	//hide the preloader
// 	document.querySelector("#preloader").style.display = "none";
// };
